import { axiosApiInstance, headers } from './_httpHeaders';

/*****************************서비스 가입********************************* */

// 1. 서비스가입 납부방식 조회
export const getInitData = (initData) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectInitData.do`,
    params: {
      agree1Code: initData.agree1Code,
      agree2Code: initData.agree2Code,
      sysGroupCode: initData.sysGroupCode,
      sysGroupCode2: initData.sysGroupCode2,
    },
  });

// 2. 서비스가입 은행계좌 조회
export const getBankAccountList = (sysGroupCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectBankAccountList.do`,
    params: {
      sysGroupCode: sysGroupCode,
    },
  });

// 3. 상담 신청 페이지 정책 조회
export const getPolicy = (agreeCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectPolicy.do`,
    params: {
      agree1Code: agreeCode.agree1Code,
      agree2Code: agreeCode.agree2Code,
    },
  });

// 4. 서비스가입 고객번호 체크
export const getCheckCustCd = (custInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectCheckCustCd.do`,
    params: {
      usCode: custInfo.custCd,
      coRprsBrno: custInfo.companyRm,
    },
  });

// 5. 서비스가입 아이디 중복 체크
export const getDupCheckUserId = (userInfo) => {
  return axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectDupCheckUserId.do`,
    params: {
      userId: userInfo.userId,
    },
  });
};

// 6. 서비스가입 회원가입
export const putJoinUserId = (userInfo) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/insertUserId.do`,
    data: {
      userChk: userInfo.userChk, // 유저체크(1:일반사용자, 0: 최초관리자)
      coRprsBrno: userInfo.coRprsBrno, //사업자 등록번호
      usCode: userInfo.usCode, // 고객코드
      companyNm: userInfo.companyNm, // 회사이름
      uptea: userInfo.uptea, // 업태
      jongmok: userInfo.jongmok, // 종목
      reprNm: userInfo.reprNm, // 대표자이름
      hpNumber: userInfo.hpNumber,
      address: userInfo.address, // 회사 우편번호
      addressDetail1: userInfo.addressDetail1, // 회사 기본주소
      addressDetail2: userInfo.addressDetail2, // 회사 상세주소
      termsType: userInfo.termsType, // 자동승인여부
      payWay: userInfo.payWay, // 납부방식
      bankCode: userInfo.bankCode, // 은행계좌
      deptNm: userInfo.deptNm, // 부서
      userId: userInfo.userId, // 아이디
      pwd: userInfo.pwd, // 비밀번호
      prvcGnrlNm: userInfo.userName, // 이름
      prvcpcmndEmail: userInfo.email, //이메일 주소
      prvcRcmndTelno: userInfo.pnumber, // 휴대폰번호
      noCert: userInfo.noCert, //사용자 입력 인증번호
      smsKey: userInfo.smsKey, //인증번호의 시퀀스 (모의해킹 취약점 조치)
      agree1Seq: userInfo.agree1Seq,
      agree1GroupCode: userInfo.agree1GroupCode,
      agree1TypeCode: userInfo.agree1TypeCode,
      agree2Seq: userInfo.agree2Seq,
      agree2GroupCode: userInfo.agree2GroupCode,
      agree2TypeCode: userInfo.agree2TypeCode,
      svcRdo1: userInfo.svcRdo1,
      svcRdo2: userInfo.svcRdo2,
      svcRdo3: userInfo.svcRdo3,
      svcRdo4: userInfo.svcRdo4,
      svcRdo5: userInfo.svcRdo5,
      svcCmb1: userInfo.svcCmb1,
      svcCmb2: userInfo.svcCmb2,
      svcCmb3: userInfo.svcCmb3,
      codeMap: userInfo.codeMap,
    },
  });
// 7. SMS발송
export const putSendSMS = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/putSendSMS.do`,
    data: {
      telNo: userInfo.telNo,
    },
  });
// 8. SMS인증 체크
export const getCheckNoCert = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/getCheckNoCert.do`,
    data: {
      noCert: userInfo.noCert,
      smsKey: userInfo.smsKey,
    },
  });

export const getComplUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/getComplUserInfo.do`,
    params: {
      userId: userInfo,
    },
  });
export const sendConfirmMsg = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/sendConfirmMsg.do`,
    data: {
      userId: userInfo,
    },
  });
export const putConfirmChk = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/putConfirmChk.do`,
    data: {
      noCert: userInfo.noCert,
      smsKey: userInfo.smsKey,
    },
  });

/******************************************로그인*********************************** */

export const setLogin = (userInfo) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setLogin.do`,
    data: {
      usId: userInfo.usId,
      pwd: userInfo.pwd,
    },
  });

export const setLogout = (usId) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setLogout.do`,
    data: {
      usId: usId,
    },
  });

//새로운정책 조회
export const getNewPolicy = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/getNewPolicy.do`,
    params: {
      userId: userInfo,
    },
  });

//새로운정책 동의
export const setNewPolicy = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setNewPolicy.do`,
    data: {
      userId: userInfo.userId,
      agree1Seq: userInfo.agree1Seq,
      groupCode1: userInfo.groupCode1,
      typeCode1: userInfo.typeCode1,
      agree2Seq: userInfo.agree2Seq,
      groupCode2: userInfo.groupCode2,
      typeCode2: userInfo.typeCode2,
    },
  });
// 비밀번호찾기
export const sendTempPwd = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/sendTempPwd.do`,
    data: {
      userId: userInfo.userId,
      coRprsBrno: userInfo.coRprsBrno,
      usCode: userInfo.usCode,
      telNo: userInfo.telNo,
      pwd: userInfo.pwd,
      status: userInfo.status,
    },
  });
// 새비밀번호설정
export const setNewPwd = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setNewPwd.do`,
    data: {
      userId: userInfo.userId,
      tmpPwd: userInfo.tmpPwd,
      pwd: userInfo.pwd,
    },
  });
// 새비밀번호설정(변경주기)
export const setNewPwdbyPeriod = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setNewPwdbyPeriod.do`,
    data: {
      userId: userInfo.userId,
      pwd: userInfo.pwd,
      newPwd: userInfo.newPwd,
    },
  });

// 비밀번호 변경주기 연장
export const setDelayPwdDt = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setDelayPwdDt.do`,
    data: {
      userId: userInfo.userId,
    },
  });

export const setLoginLog = (usId) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/setLoginLog.do`,
    data: {
      usId: usId,
    },
  });

/*************************************************************************** */
/*************************마이페이지************************************* */
// 크리덴셜스터핑 개인정보 유출 대응 강화 조치 - 마스킹된 개인정보 조회 (개인정보 조회 화면)
export const getMpUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getMpUserInfo.do`,
    params: {
      // userId: userInfo.userId,
      userId: userInfo,
    },
  });

// 크리덴셜스터핑 개인정보 유출 대응 강화 조치 - 개인정보 조회 (2차인증검증 후 개인정보 수정 화면 접근)
export const getMpUserInfoWithVerify = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: {
      'content-type': 'application/json;charset=UTF-8',
      'X-TFA-TKN': userInfo.tfaTkn,
    },
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getMpUserInfoWithVerify.do`,
    params: {
      userId: userInfo.userId,
    },
  });

// 기존 개인정보 조회 API
export const getUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getUserInfo.do`,
    params: {
      userId: userInfo,
    },
  });

export const getCorpInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getCorpInfo.do`,
    params: {
      userId: userInfo,
    },
  });
export const updateUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/updateUserInfo.do`,
    data: {
      userId: userInfo.userId,
      prvcRcmndTelno: userInfo.prvcRcmndTelno,
      prvcpcmndEmail: userInfo.prvcpcmndEmail,
      policySeq: userInfo.policySeq,
      groupCode: userInfo.groupCode,
      typeCode: userInfo.typeCode,
      usCode: userInfo.usCode,
    },
  });
export const updateUserPwd = (userInfo) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/updateUserPwd.do`,
    data: {
      userId: userInfo.userId,
      pwd: userInfo.pwd,
      newPwd: userInfo.newPwd,
    },
  });
export const deleteUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/deleteUserInfo.do`,
    data: {
      userId: userInfo.userId,
      pwd: userInfo.pwd,
    },
  });

export const updateCorpInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/updateCorpInfo.do`,
    data: {
      coNm: userInfo.coNm,
      coBizcnd: userInfo.coBizcnd,
      coInduty: userInfo.coInduty,
      coRprsNm: userInfo.coRprsNm,
      coTelNo: userInfo.coTelNo,
      coZip: userInfo.coZip,
      coAddr1: userInfo.coAddr1,
      coAddr2: userInfo.coAddr2,
      atmcAprvYn: userInfo.atmcAprvYn,
      payWay: userInfo.payWay,
      bankAccount: userInfo.bankAccount,
      bankNm: userInfo.bankNm,
      usCode: userInfo.usCode,
      coBrno: userInfo.coBrno,
    },
  });

export const deleteCorpInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/deleteCorpInfo.do`,
    data: {
      userId: userInfo.userId,
      pwd: userInfo.pwd,
      usCode: userInfo.usCode,
    },
  });

export const getSvcRptInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getSvcRptInfo.do`,
    params: {
      userId: userInfo,
    },
  });

export const updateSvcRptInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/updateSvcRptInfo.do`,
    data: {
      svcRdo1: userInfo.svcRdo1,
      svcRdo1Org: userInfo.svcRdo1Org,
      ediFeeType: userInfo.ediFeeType,
      ediFeeTypeOrg: userInfo.ediFeeTypeOrg,
      svcReqEdiCan: userInfo.svcReqEdiCan,
      setupYn: userInfo.setupYn,
      svcRdo2: userInfo.svcRdo2,
      svcRdo2Org: userInfo.svcRdo2Org,
      wscFeeType: userInfo.wscFeeType,
      wscFeeTypeOrg: userInfo.wscFeeTypeOrg,
      svcReqWscCan: userInfo.svcReqWscCan,
      svcRdo3: userInfo.svcRdo3,
      svcRdo3Org: userInfo.svcRdo3Org,
      onlFeeType: userInfo.onlFeeType,
      onlFeeTypeOrg: userInfo.onlFeeTypeOrg,
      svcReqOnlCan: userInfo.svcReqOnlCan,
      svcRdo4: userInfo.svcRdo4,
      svcRdo4Org: userInfo.svcRdo4Org,
      svcRdo5: userInfo.svcRdo5,
      svcRdo5Org: userInfo.svcRdo5Org,
      codeMap: userInfo.codeMap,
    },
  });

export const getSvcRptHistInitData = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getSvcRptHistInitData.do`,
    params: {},
  });

export const getSvcRptHistList = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getSvcRptHistList.do`,
    params: {
      rptEngineCode: userInfo.rptEngineCode,
      reqStatus: userInfo.reqStatus,
      reqType: userInfo.reqType,
      termsType: userInfo.termsType,
      startDt: userInfo.startDt,
      endDt: userInfo.endDt,
      pageStart: userInfo.pageStart,
      perPageNum: userInfo.perPageNum,
    },
  });
export const cancelSvcRptInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/cancelSvcRptInfo.do`,
    data: {
      svcReqEdiCan: userInfo.svcReqEdiCan,
      svcReqWscCan: userInfo.svcReqWscCan,
      svcReqOnlCan: userInfo.svcReqOnlCan,
    },
  });
